// src/utils/secureLogger.ts
import * as Sentry from '@sentry/react';

export class SecureLogger {
    private static isDevelopment = process.env.NODE_ENV === 'development';
  
    static debug(message: string, ...args: any[]) {
      if (this.isDevelopment) {
        console.log(`[DEBUG] ${message}`, ...args);
      }
    }
  
    static info(message: string, ...args: any[]) {
      if (this.isDevelopment) {
        console.info(`[INFO] ${message}`, ...args);
      }
    }
  
    static warn(message: string, ...args: any[]) {
      if (this.isDevelopment) {
        console.warn(`[WARN] ${message}`, ...args);
      } else {
        // En production, logger seulement l'essentiel
        console.warn(`[WARN] ${message}`);
      }
    }
  
    static error(message: string, error?: Error, context?: string) {
      if (this.isDevelopment) {
        console.error(`[ERROR] ${context ? `[${context}] ` : ''}${message}`, error);
      } else {
        // En production, ne pas exposer les détails d'erreur en console
        console.error(`[ERROR] ${context ? `[${context}] ` : ''}${message}`);

        // L'objet Error complet (avec sa stack) part quand même vers Sentry
        this.sendToMonitoring(message, error, context);
      }
    }

    private static sendToMonitoring(message: string, error?: Error, context?: string) {
      // Intégration Sentry (no-op silencieux si le SDK n'est pas initialisé, cf. src/index.tsx)
      if (error) {
        Sentry.captureException(error, {
          tags: context ? { context } : undefined,
          extra: { message },
        });
      } else {
        Sentry.captureMessage(message, {
          level: 'error',
          tags: context ? { context } : undefined,
        });
      }
    }
  }